import React from 'react';
import { CheckoutButton } from '../CheckoutButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCta() {
  return <section className="relative overflow-hidden bg-navy-950 px-4 py-14 text-white sm:py-20" data-id="element-154" data-mp="1nozqd7fngs78">
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-72 bg-[radial-gradient(circle_at_50%_100%,rgba(46,163,232,0.25),transparent_65%)]" aria-hidden="true" data-id="element-155" data-mp="1so2saj0c2iaz" />
      <div className="relative mx-auto w-full max-w-2xl text-center" data-id="element-156" data-mp="1ipwry5u6dk88">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-aqua-200" data-id="element-157" data-mp="1ir7ygdf09631">
          🧭 Ready to stop studying without a plan?
        </p>
        <h2 className="mt-4 font-display text-[30px] font-bold leading-[1.1] tracking-tight sm:text-5xl" data-id="element-158" data-mp="19of4u3icoia1">
          15 minutes. One clear path.{' '}
          <span className="italic text-aqua-400" data-id="element-159" data-mp="2z2229p6t0tl2">One concept at a time.</span>
        </h2>
        <p className="mt-5 text-[15.5px] leading-relaxed text-white/70 sm:text-lg" data-id="element-160" data-mp="342gcndvvofm9">
          Stop opening another PDF and wondering where to begin. Open PROSTHO 360™, follow the map, and review
          one concept at a time.
        </p>

        <div className="mt-8" data-id="element-161" data-mp="b16trpo9p5vl">
          <CheckoutButton label="Get Prostho 360™" sub="Just $27 · Instant access · Lifetime access · 7-Day Guarantee" data-id="element-162" data-mp="b055ukm5kowg" />
        </div>

        <div className="mt-8" data-id="element-163" data-mp="3ff4yu76yenl5">
          <Countdown tone="dark" data-id="element-164" data-mp="3fgg1u4skrrb7" />
        </div>

        <div className="mt-6" data-id="element-165" data-mp="3agjym7rpc3wp">
          <ScarcityBar tone="dark" data-id="element-166" data-mp="3ahbwjp8rudq5" />
        </div>
      </div>
    </section>;
}